import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PageUserResponse, UserResponse } from '~/Services/AdminUsers'

export interface UsersReducerStore {
  listUsersData: PageUserResponse | null
}

const initialState: UsersReducerStore = {
  listUsersData: null,
}

export const UsersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    getUsersRequest: () => {},
    setUsersSuccess: (state, action) => {
      state.listUsersData = action.payload
      console.log('setUsersSuccess', state.listUsersData)
    },
    setUsersError: state => {
      state.listUsersData = null
    },
    addUsersRequest: (state, action: PayloadAction<string>) => {},

    addUsersuccess: (state, _action: PayloadAction<any>) => {},
    addUsersError: state => {},
    updateUsersRequest: (
      _state,
      _action: PayloadAction<{ UsersName: string; newUsersname: string }>,
    ) => {},
    updateUsersuccess: (state, _action: PayloadAction<any>) => {},
    updateUsersError: state => {},

    deleteUsersRequest: (_state, _action: PayloadAction<string>) => {},
    deleteUsersuccess: (state, _action: PayloadAction<any>) => {},
    deleteUsersError: state => {},
  },
})

export const UsersActions = UsersSlice.actions
export const UsersReducer = UsersSlice.reducer
